import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { GameContainer } from './component/gamecontainer';
import { JonathanGee } from './component/jonathangee';
import { ShowPlayAGame } from './component/playagame';
import { waitMS } from './utils';

const useStyles = makeStyles(theme=>({
	app:{
		backgroundColor:theme.palette.background.default,
		display:'flex',
		justifyContent:'center',
		alignItems:'center',
		minHeight:'100vh',
		flexDirection:'column',
		margin:0,
	}
}))

function App() {

	const classes = useStyles();
	const [showPlayAGame,setShowPLayAGame] = useState(false);
	const [showGameContainer,setShowGameContainer] = useState(false);

	useEffect(() => {

		const appDelay = async () => {
			await waitMS(30000);
			setShowPLayAGame(true);
		};

		appDelay();
	}, []);

	return (
		<div className={classes.app}>
			<JonathanGee />
			{showPlayAGame && !showGameContainer &&
				<ShowPlayAGame onPlay={()=>setShowGameContainer(true)} />}
			{showGameContainer &&
				<GameContainer />}
		</div>
	);
}

export default App;
